var _mask, _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_455_2732",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 2.45637C40.5 1.09975 41.6009 -0.00776349 42.955 0.0744599C49.8529 0.493308 56.5439 2.67174 62.3819 6.42022C68.9104 10.612 74.0975 16.5908 77.3262 23.6454C80.555 30.7 81.6895 38.5335 80.5949 46.2142C79.5002 53.895 76.2225 61.0997 71.1515 66.9714C66.0805 72.8431 59.4297 77.1348 51.9901 79.3359C44.5506 81.537 36.6353 81.5549 29.1859 79.3875C21.7364 77.2201 15.0662 72.9587 9.9687 67.11C5.41029 61.8798 2.28103 55.5772 0.862482 48.8137C0.584009 47.486 1.51947 46.2357 2.86164 46.0382C4.2038 45.8407 5.4434 46.7713 5.73298 48.0966C7.00737 53.9293 9.73227 59.3616 13.6722 63.8821C18.1514 69.0214 24.0125 72.7659 30.5583 74.6704C37.1041 76.5749 44.0592 76.5591 50.5964 74.625C57.1335 72.6909 62.9775 68.9199 67.4334 63.7604C71.8893 58.6009 74.7694 52.2701 75.7313 45.5211C76.6931 38.772 75.6962 31.8887 72.8591 25.6899C70.022 19.491 65.4641 14.2375 59.7276 10.5542C54.6816 7.31427 48.9105 5.4092 42.9545 4.99747C41.6011 4.90391 40.5 3.81298 40.5 2.45637Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 2.45637C40.5 1.09975 41.6009 -0.00776349 42.955 0.0744599C49.8529 0.493308 56.5439 2.67174 62.3819 6.42022C68.9104 10.612 74.0975 16.5908 77.3262 23.6454C80.555 30.7 81.6895 38.5335 80.5949 46.2142C79.5002 53.895 76.2225 61.0997 71.1515 66.9714C66.0805 72.8431 59.4297 77.1348 51.9901 79.3359C44.5506 81.537 36.6353 81.5549 29.1859 79.3875C21.7364 77.2201 15.0662 72.9587 9.9687 67.11C5.41029 61.8798 2.28103 55.5772 0.862482 48.8137C0.584009 47.486 1.51947 46.2357 2.86164 46.0382C4.2038 45.8407 5.4434 46.7713 5.73298 48.0966C7.00737 53.9293 9.73227 59.3616 13.6722 63.8821C18.1514 69.0214 24.0125 72.7659 30.5583 74.6704C37.1041 76.5749 44.0592 76.5591 50.5964 74.625C57.1335 72.6909 62.9775 68.9199 67.4334 63.7604C71.8893 58.6009 74.7694 52.2701 75.7313 45.5211C76.6931 38.772 75.6962 31.8887 72.8591 25.6899C70.022 19.491 65.4641 14.2375 59.7276 10.5542C54.6816 7.31427 48.9105 5.4092 42.9545 4.99747C41.6011 4.90391 40.5 3.81298 40.5 2.45637Z",
    stroke: "#8276F4",
    strokeWidth: 10.9431,
    mask: "url(#path-1-inside-1_455_2732)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_455_2732)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 29.5,
    fill: "url(#paint0_linear_455_2732)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3094 48.216C29.8454 48.216 29.4694 48.112 29.1814 47.904C28.8934 47.68 28.7254 47.392 28.6774 47.04C28.6294 46.688 28.7254 46.296 28.9654 45.864L35.9014 33V34.152H28.6534C28.1254 34.152 27.7254 34.024 27.4534 33.768C27.1814 33.496 27.0454 33.112 27.0454 32.616C27.0454 32.12 27.1814 31.744 27.4534 31.488C27.7254 31.216 28.1254 31.08 28.6534 31.08H37.7974C38.3094 31.08 38.7254 31.216 39.0454 31.488C39.3814 31.76 39.5494 32.144 39.5494 32.64C39.5494 33.072 39.4854 33.448 39.3574 33.768C39.2454 34.088 39.0934 34.432 38.9014 34.8L32.4214 47.016C32.1974 47.432 31.9174 47.736 31.5814 47.928C31.2454 48.12 30.8214 48.216 30.3094 48.216ZM43.812 48C43.22 48 42.78 47.864 42.492 47.592C42.22 47.304 42.084 46.888 42.084 46.344C42.084 45.992 42.172 45.664 42.348 45.36C42.524 45.056 42.764 44.744 43.068 44.424L47.58 39.672C48.252 38.952 48.732 38.312 49.02 37.752C49.324 37.192 49.476 36.632 49.476 36.072C49.476 35.368 49.244 34.832 48.78 34.464C48.332 34.096 47.676 33.912 46.812 33.912C46.348 33.912 45.868 33.984 45.372 34.128C44.892 34.256 44.388 34.472 43.86 34.776C43.508 34.968 43.18 35.04 42.876 34.992C42.588 34.928 42.34 34.792 42.132 34.584C41.924 34.36 41.788 34.096 41.724 33.792C41.66 33.488 41.692 33.184 41.82 32.88C41.948 32.576 42.188 32.32 42.54 32.112C43.244 31.68 44.012 31.36 44.844 31.152C45.676 30.928 46.5 30.816 47.316 30.816C48.58 30.816 49.644 31.008 50.508 31.392C51.372 31.76 52.028 32.304 52.476 33.024C52.924 33.744 53.148 34.624 53.148 35.664C53.148 36.336 53.044 36.992 52.836 37.632C52.628 38.272 52.3 38.92 51.852 39.576C51.42 40.216 50.844 40.904 50.124 41.64L45.924 45.912V44.952H52.428C52.94 44.952 53.324 45.08 53.58 45.336C53.852 45.592 53.988 45.968 53.988 46.464C53.988 46.96 53.852 47.344 53.58 47.616C53.324 47.872 52.94 48 52.428 48H43.812Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_455_2732",
    x: 7.35229,
    y: 11,
    width: 66.2954,
    height: 68.1193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.64771,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_455_2732"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.47156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.64771
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509804 0 0 0 0 0.462745 0 0 0 0 0.956863 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_455_2732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_455_2732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_455_2732",
    x1: 34.3333,
    y1: 16.5,
    x2: 53.1667,
    y2: 71.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABA3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C54AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePercentage);
export default __webpack_public_path__ + "static/media/mobile_percentage.01bb91a50059ee099e4159f2cac6dfce.svg";
export { ForwardRef as ReactComponent };